import React from 'react'
import { Component } from 'react';
import ReactDOM from "react-dom";

import AutocompleteInput from "../../expert_search/js/components/AutocompleteInput";


class SearchField extends Component {

    state = {
        value: "",
    };

    onValueChange = (value) => {
        this.setState({value: value});
    };

    onSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (this.state.value.length) {
            const hash = `Zitat-Text=${encodeURIComponent(this.state.value)}`;
            window.location.href = "/suche/#" + hash;
        }
    };

    render() {
        const { autocomplete } = this.props;

        return (
            <form onSubmit={this.onSubmit}>
                <input type={"submit"} hidden={"hidden"}/>
                <div className={'grid-x'}>
                    <div className={'cell auto'}>
                        <AutocompleteInput
                            items={autocomplete}
                            value={this.state.value}
                            onValueChange={this.onValueChange}
                            placeholder={"Volltextsuche"}
                        />
                    </div>
                    <div className={"cell shrink"}>
                        <button type="submit" className="button no-margin">suchen</button>
                    </div>
                </div>
            </form>
        );
    }
}

export default SearchField;


// WEBPACK FOOTER //
// ./cms_plugins/search_field/js/SearchField.js